// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2fW5K","dragIcon":"Choice_dragIcon__2R0kH","left":"Choice_left__iEjul","input":"Choice_input__jygcn"};